<template>
	<div class="right_content_container">
		<div class="flex_between">
			<div class="left_title">权限配置</div>
			<div @click="addNewAccount" class="add_btn flex_center">
				<p style="margin-top: -2px">+&nbsp;</p>
				<p>{{ roleType === "SUPER_ADMIN" ? "新增账号" : "新增客服账号" }}</p>
			</div>
		</div>

		<div v-if="permissionList.length > 0" class="table_plate">
			<el-table
				:data="permissionList"
				height="100%"
				:header-cell-style="{ 'background-color': '#F7F5FA' }"
			>
				<el-table-column
					v-for="(item, index) in permissionTable"
					:key="index"
					:prop="item.props"
					:label="item.label"
				/>
				<el-table-column fixed="right" label="操作">
					<template #default="scope">
						<div class="list_btn">
							<span class="edit" @click="getAction(scope.row, 'edit')">編輯</span>
							<span class="delete" @click="getAction(scope.row, 'del')">刪除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- <div class="pagination">
				<el-pagination :page-size="20" :pager-count="11" layout="prev, pager, next" :total="1000" />
			</div> -->
		</div>

		<div v-else class="global_none_data">
			<div class="flex_center">
				<img src="../assets/none_thing/none_account_image.png" />
			</div>
			<p>暂无账号</p>
		</div>
		<el-dialog
			title=""
			:close-on-click-modal="false"
			:show-close="false"
			center
			v-model="rootDialogVisible"
			style="padding: 40px 0; padding-bottom: 20px"
		>
			<template #header>
				<p class="dialog_title">{{ dialogTitle }}</p>
			</template>
			<div class="flex_center">
				<el-form :model="form" style="width: 66%" label-width="auto">
					<el-form-item>
						<span class="label_name">*登陆手机号</span>
						<el-input
							:disabled="form.id && !changePhoneNum ? true : false"
							v-model="form.phone"
							placeholder="请输入登陆手机号"
							@input="checkCode"
							:maxlength="11"
							style="flex: 1"
							:style="{ width: form.id ? 'calc(100% - 190px)' : 'calc(100% - 132px)' }"
						/>
						<span v-if="form.id" class="change_button" @click="changePhoneNum = true">修改</span>
					</el-form-item>
					<el-form-item v-if="changePhoneNum">
						<span class="label_name">*验证码</span>
						<el-input
							v-model="form.code"
							maxlength="6"
							@input="checkCode"
							placeholder="请输入登陆手机号验证码"
							style="flex: 1; margin-right: 10px"
						/>
						<el-button
							style="width: 102px"
							:disabled="showText"
							type="primary"
							v-throttle="sendCode"
						>
							{{ showText ? downTime + "s后重新获取" : "获取验证码" }}
						</el-button>
					</el-form-item>
					<el-form-item>
						<span class="label_name">*昵称</span>
						<el-input
							v-model="form.nick"
							@blur="checkoutValue('nick', form.nick)"
							placeholder="请输入账号昵称，会显示在用户端"
							style="flex: 1"
						/>
					</el-form-item>
					<el-form-item>
						<span class="label_name">*备注</span>
						<el-input
							v-model="form.commentValue"
							@blur="checkoutValue('commentValue', form.commentValue)"
							placeholder="请输入备注"
							style="flex: 1"
						/>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<span class="label_name">角色</span>
						<el-radio-group v-model="form.roleValue">
							<el-radio
								v-for="(role, index) in roleTypeArray"
								:key="index"
								:value="role.type"
								style="margin-right: 24px"
							>
								{{ role.name }}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="rootDialogVisible = false">取消</el-button>
					<el-button type="primary" v-throttle="saveData"> 保存 </el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { post, get, deleteRe, put } from "../utils/request";
import { message } from "@/utils/resetMessage";
const { proxy } = getCurrentInstance();
const rootDialogVisible = ref(false);
const form = ref({});
const permissionTable = ref([]);
const permissionList = ref([]);
const downTime = ref(60);
const showText = ref(false);
const dialogTitle = ref("新增账号");
const changePhoneNum = ref(false);
const roleTypeArray = ref([]);
const roleType = ref("");
const timer = ref(null);

onMounted(() => {
	roleType.value = sessionStorage.userType;
	if (roleType.value === "SUPER_ADMIN") {
		permissionTable.value = [
			{
				props: "id",
				label: "用户ID",
			},
			{
				props: "username",
				label: "用户账号",
			},
			{
				props: "role",
				label: "角色",
			},
			{
				props: "permissionName",
				label: "权限",
			},
			{
				props: "lastLoginTime",
				label: "最后登录时间",
			},
			{
				props: "authorizedAccount",
				label: "授权人账号",
			},
		];
		roleTypeArray.value = [
			{
				type: "SUPER_ADMIN",
				name: "超级管理员",
			},
			{
				type: "KEFU_ADMIN",
				name: "客服管理员",
			},
			{
				type: "KEFU",
				name: "普通客服",
			},
		];
	} else if (roleType.value === "KEFU_ADMIN") {
		permissionTable.value = [
			{
				props: "id",
				label: "用户ID",
			},
			{
				props: "username",
				label: "用户账号",
			},
			{
				props: "role",
				label: "角色",
			},
			{
				props: "permissionName",
				label: "权限",
			},
			{
				props: "lastLoginTime",
				label: "最后登录时间",
			},
		];
		roleTypeArray.value = [
			{
				type: "KEFU",
				name: "普通客服",
			},
		];
	}
	getDataList();
});

// 操作
const getAction = (data, type) => {
	if (type == "edit") {
		form.value.id = data.id;
		form.value.phone = data.username;
		form.value.nick = data.nickname;
		form.value.commentValue = data.comment;
		form.value.code = "";

		if (data.role === "超级管理员") {
			form.value.roleValue = "SUPER_ADMIN";
		} else if (data.role === "客服管理员") {
			form.value.roleValue = "KEFU_ADMIN";
		} else {
			form.value.roleValue = "KEFU";
		}
		dialogTitle.value = "编辑账号";
		downTime.value = 60;
		showText.value = false;
		changePhoneNum.value = false;
		rootDialogVisible.value = true;
	} else {
		proxy.$confirm("是否删除该账号？", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			center: true,
			showClose: false,
			closeOnClickModal: false,
			closeOnPressEscape: false,
			callback: (type) => {
				if (type === "confirm") {
					deleteFn(data.id);
				}
			},
		});
	}
};
const checkCode = () => {
	if (form.value.phone) {
		form.value.phone = form.value.phone.replace(/[^0-9]/g, "");
	}
	if (form.value.code) {
		form.value.code = form.value.code.replace(/[^0-9]/g, "");
	}
};
// 获取列表
const getDataList = () => {
	get("/api-cms/user/list", {})
		.then((res) => {
			if (res.code === 1) {
				res.result.forEach((item) => {
					if (item.lastLoginTime) {
						item.lastLoginTime = proxy.$date(item.lastLoginTime).format("YYYY.MM.DD HH:mm:ss");
					}

					if (item.role === "SUPER_ADMIN") {
						item.role = "超级管理员";
					} else if (item.role === "KEFU_ADMIN") {
						item.role = "客服管理员";
					} else {
						item.role = "客服";
					}
				});
				permissionList.value = res.result;
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

// 删除账号
const deleteFn = (id) => {
	deleteRe("/api-cms/user/" + id, {})
		.then((res) => {
			if (res.code === 1) {
				message.success("删除成功");
				getDataList();
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

// 新增账号
const addNewAccount = () => {
	form.value = {};
	downTime.value = 60;
	showText.value = false;
	dialogTitle.value = "新增账号";
	changePhoneNum.value = true;
	rootDialogVisible.value = true;
};

// 纯数字校验
const checkoutValue = (type, data) => {
	let firstReg = /^[^\s]+[\s]*.*$/;
	let reg = /^\d+$/;
	if (data && !firstReg.test(data)) {
		if (type === "username" && !reg.test(data)) {
			form.value.phone = "";
		} else if (type === "verificationCode" && !reg.test(data)) {
			form.value.code = "";
		} else if (type === "nick") {
			form.value.nick = "";
		} else if (type === "commentValue") {
			form.value.commentValue = "";
		}
	} else {
		if (type === "username" && !reg.test(data)) {
			form.value.phone = "";
		} else if (type === "verificationCode" && !reg.test(data)) {
			form.value.code = "";
		}
	}
};

// 输入框为空校验
const saveData = () => {
	if (!form.value.phone) {
		proxy.$message({
			message: "请输入登陆手机号",
			type: "error",
		});

		return;
	}

	if (changePhoneNum.value == true && !form.value.code) {
		proxy.$message({
			message: "请输入验证码",
			type: "error",
		});

		return;
	}

	if (!form.value.nick) {
		proxy.$message({
			message: "请输入昵称",
			type: "error",
		});

		return;
	}

	if (!form.value.commentValue) {
		proxy.$message({
			message: "请输入备注",
			type: "error",
		});

		return;
	}

	if (!form.value.roleValue) {
		proxy.$message({
			message: "请选择角色",
			type: "error",
		});

		return;
	}

	submitData();
};

// 提交数据
const submitData = () => {
	let params;
	if (form.value.id) {
		params = {
			id: form.value.id,
			username: form.value.phone,
			nickname: form.value.nick,
			comment: form.value.commentValue,
			role: form.value.roleValue,
			verificationCode: form.value.code,
		};
	} else {
		params = {
			username: form.value.phone,
			nickname: form.value.nick,
			comment: form.value.commentValue,
			role: form.value.roleValue,
			verificationCode: form.value.code,
		};
	}

	if (form.value.id) {
		put("/api-cms/user", params)
			.then((res) => {
				if (res.code === 1) {
					rootDialogVisible.value = false;
					message.success("保存成功");
					getDataList();
				}
			})
			.catch((error) => {
				console.log(error);
			});
	} else {
		post("/api-cms/user", params)
			.then((res) => {
				if (res.code === 1) {
					rootDialogVisible.value = false;
					message.success("保存成功");
					getDataList();
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
};

// 获取验证码
const sendCode = () => {
	clearInterval(timer.value);
	if (!form.value.phone) {
		proxy.$message({
			message: "请输入登陆手机号",
			type: "error",
		});

		return;
	}
	if (showText.value) {
		return;
	}
	downTime.value = 60;
	showText.value = true;
	timer.value = setInterval(() => {
		if (downTime.value > 0) {
			downTime.value--;
		} else {
			if (downTime.value <= 0) {
				clearInterval(timer.value);
				showText.value = false;
			}
		}
	}, 1000);
	get(`/api-oauth/auth/code/sms?mobile=${form.value.phone}`)
		.then((res) => {
			if (res.code === 1) {
				message.success("验证码已发送");
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
</script>
<style scoped lang="less">
.list_btn {
	.edit {
		color: #16305d;
		cursor: pointer;
	}
	.delete {
		margin-left: 30px;
		color: #f74e49;
		cursor: pointer;
	}
}
.pagination {
	position: absolute;
	bottom: 30px;
	right: 20px;
}
.label_name {
	width: 85px;
	font-size: 14px;
	color: #606266;
	text-align: right;
	margin-right: 20px;
}
.change_button {
	padding: 5px;
	color: #a15bff;
	font-size: 14px;
	margin-left: 20px;
	cursor: pointer;
}
</style>
